import React from "react";
import ModuleTreeStrucutre from "../Components/ModuleTreeStructure/ModuleTreeStrucutre";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function ModuleStructure() {
  const location = useLocation();
  const data = location.state || {};
  console.log(data);
  const navigate = useNavigate();
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  const handleNavigate = () => {
    navigate(`/programs/${data.program_id}`);
  };

  return (
    <div>
      <h1 className="text-center mt-3">{t("module_structure_title")}</h1>
      <p className="text-muted text-center">
        {t("module_structure_description")}
      </p>
      <ModuleTreeStrucutre />
    </div>
  );
}

export default ModuleStructure;
